<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit(
							$route(
								'tenant.reservations.index',
								$page.props.tenant.id
							)
						)
					"
				>
					<v-icon>mdi-arrow-left</v-icon>
				</v-btn>
				<strong class="pl-4"> {{ data.outlet_name }}</strong>
				<v-spacer></v-spacer>
				<!-- <v-btn
					color="primary"
					dark
					class="mr-2"
					:href="printReservation"
					target="_blank"
				>
					<v-icon left>mdi-printer</v-icon>{{ $t("label.print") }}
				</v-btn> -->
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<v-card outlined>
							<v-card-text>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("label.customer_name") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{
												data
													? data.customer_name
													: "N/A"
											}}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("label.outlet_name") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{
												data ? data.outlet_name : "N/A"
											}}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("Date") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{ data ? data.date : "N/A" }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("Time") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{ data ? data.time : "N/A" }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("label.adults") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{ data ? data.adults : "N/A" }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("label.children") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{ data ? data.children : "N/A" }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("Status") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{ data ? data.status : "N/A" }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>
											{{ $t("label.comment") }}:
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-content>
										<v-list-item-title
											class="font-weight-bold"
										>
											{{
												data ? data.description : "N/A"
											}}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["data"],

	computed: {
		printReservation() {
			///
		},
	},
};
</script>